import React, { useState, useEffect, useRef, useCallback } from 'react';
import '../css/Chatbot.css';
import Icon from '../assests/Spark_logo.png';
import { FaPaperPlane, FaEye, FaMicrophone, FaVolumeUp, FaStop, FaDownload, FaFilePdf, FaRegFilePdf } from 'react-icons/fa';
import KpointPlayer from './kpointplayer'; // Assuming this is your custom KPoint player component
import { PulseLoader, ClipLoader } from 'react-spinners';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faDownload, faEye, faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons';
import ReactGA from 'react-ga4';// Initialize Google Analytics
import {storeChatMessage, updateSessionEndTime, updateChatFeedback} from './log';
import { collection, doc, setDoc } from "firebase/firestore";
import { v4 as uuidv4 } from "uuid"; 
import Badge from 'react-bootstrap/Badge'
ReactGA.initialize('G-W6N86H74EH');

const Chatbot = ({tag, query_para, lang}) => {
  const [messageList, setMessageList] = useState([]);
  const playerRefs = useRef({});  // To store refs for each videoId
  const [query, setQuery] = useState(query_para || '');
  const [selectedLanguage, setSelectedLanguage] = useState(lang || 'English');
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [conversation, setConversation] = useState([
    { text: 'Hello! How may I help you today?', isUser: false },
  ]);
  const [videoTitles, setVideoTitles] = useState({}); // Store video titles and thumbnails
  const [placeholder, setPlaceholder] = useState('Type your message');
  const chatbotBodyRef = useRef(null);
  const [loading, setLoading] = useState(false); // Add loading state
  const [isRecording, setIsRecording] = useState(false); // Recording state
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const silenceTimer = useRef(null);
  const analyserRef = useRef(null);
  const MIN_DECIBELS = -90; 
  const [speechloading, setSpeechLoading] = useState(false); 
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null); // Create audio reference
  const [sessionId, setSessionId] = useState(null);
  const [userId, setUserId] = useState(null);
  let chatId ='';
  useEffect(() => {
    const storedSessionId = localStorage.getItem("accessToken") || "anonymous"; // Default to "anonymous"
    const storedUserProfile = localStorage.getItem("userProfile");
  
    setSessionId(storedSessionId);
  
    if (storedUserProfile) {
      try {
        const parsedProfile = JSON.parse(storedUserProfile);
        if (!parsedProfile?.email) {
          console.warn("User email not found in profile");
        }
        setUserId(parsedProfile?.email || "anonymous"); // Default to "anonymous" if email is missing
      } catch (error) {
        console.error("Error parsing userProfile:", error);
        setUserId("anonymous");
      }
    } else {
      setUserId("anonymous"); // Ensure userId is set to "anonymous" if userProfile is missing
    }
  }, []);
  

  // Run only on first load with URL params
  useEffect(() => {
    if (isFirstLoad && tag && query_para && lang) {
      if (typeof handleSend === "function") {
        console.log("Calling handleSend...");
        console.log("value of first load : ",isFirstLoad);
        handleSend();
      } else {
        console.error("handleSend is not a function");
      }
    }
  }, [isFirstLoad, tag, query_para, lang]);
  
  // Runs when URL changes
  const handlePlayerReady = useCallback((playerRef, videoId) => {
    
    if (playerRef) {
      playerRefs.current[videoId] = playerRef;
      //console.log(`Player is ready for video ${videoId}`, playerRef); 
    } else {
      console.error("kPlayer is undefined for video", videoId);
    }
  }, []); 
  
  const onStateChange = useCallback((state, videoId) => {
    //console.log(`Player state changed for video ${videoId}:`, state["data"]);
  }, []);  

   // Audio Recording Functions
  const startRecording = () => {
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then(stream => {
        mediaRecorderRef.current = new MediaRecorder(stream);
        audioChunksRef.current = []; // Reset audio chunks

        mediaRecorderRef.current.ondataavailable = event => {
          audioChunksRef.current.push(event.data);
        };

        mediaRecorderRef.current.onstop = () => {
          const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
          sendAudioToServer(audioBlob);
        };

        mediaRecorderRef.current.start();
        console.log("recording started");
        setIsRecording(true);
        setPlaceholder('Speak now');

        const audioContext = new AudioContext();
        const audioStreamSource = audioContext.createMediaStreamSource(stream);
        analyserRef.current = audioContext.createAnalyser();
        analyserRef.current.minDecibels = MIN_DECIBELS;
        audioStreamSource.connect(analyserRef.current);

        // detectSilence(); // Start silence detection loop
        // resetSilenceTimer(); // Start silence timer
      })
      .catch(err => {
        console.error("Error accessing microphone:", err);
      });
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && isRecording) {
      mediaRecorderRef.current.stop();
      console.log("stopped recording");
      clearTimeout(silenceTimer.current);
      setIsRecording(false);
      setPlaceholder('Transcribing...');
    }
  };

  const handleRecording = () => {
    if (isRecording) {
      stopRecording();
    } else {
      startRecording();
    }
  };

  const sendAudioToServer = (audioBlob) => {
    const reader = new FileReader();
    reader.readAsDataURL(audioBlob);
    // const a = Base64.encode(reader.readAsDataURL(audioBlob));
    reader.onloadend = () => {
      const base64Audio = reader.result.split(',')[1]; 
  
      // fetch('https://km0yl5vd0a.execute-api.ap-south-1.amazonaws.com/dev/stt-audio', {
      fetch('https://7d3m1ntlhf.execute-api.ap-south-1.amazonaws.com/dev/stt-audio', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          audio: base64Audio,
          language: selectedLanguage, 
        }),
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}, body: ${response.body}`);
        }
        return response.json();
      })
      .then(data => {
        setQuery(data.transcript || '');
        setPlaceholder('Type your message');
      })
      .catch(error => {
        console.error('Error:', error);
        setPlaceholder('Type your message');
      });
    };
  };
  

  const handleLanguageChange = (event) => {
    setSelectedLanguage(event.target.value);
  };

  // Fetch video titles for each video ID in the videoLinks array
  const fetchVideoTitle = async (id) => {
    try {
      const response = await fetch(`https://ktpl.kpoint.com/api/v3/videos/${id}`);
      const data = await response.json();
      return data.displayname || 'Untitled Video';
    } catch (error) {
      console.error("Error fetching video info:", error);
      return 'Untitled Video';
    }
  };

  const fetchVideoTitles = async (videoLinks) => {
    const titles = {};
    await Promise.all(
      videoLinks.map(async (video) => {
        const title = await fetchVideoTitle(video.id);
        titles[video.id] = title;
      })
    );
    setVideoTitles(titles);
  };

  useEffect(() => {
    // Load messages from localStorage when component mounts
    const savedMessages = JSON.parse(localStorage.getItem('messageList')) || [];
    setMessageList(savedMessages);
    //ReactGA.send({ hitType: "pageview", page: window.location.pathname  + window.location.search});
  }, []);

  const saveMessage = (role, content) => {
    const newMessage = { role, content };
    setMessageList(prevList => {
      const updatedList = [...prevList, newMessage];
      localStorage.setItem('messageList', JSON.stringify(updatedList));
      return updatedList;
    });
  };
  // Get recent 3 user and assistant messages
  const getRecentMessages = () => {
    return messageList.slice(-6);
  };

  const handleSend = async () => {
    chatId = uuidv4();
    let formattedQueryParam = query_para ? decodeURIComponent(query_para) : ''; 
    let userQuery = '';

    if (query.trim() !== '') {
        userQuery = query;  // If user input exists, use it
    } else if (formattedQueryParam.trim() !== '') {
        userQuery = formattedQueryParam;  // Use URL parameter if no input
    }
    if (userQuery !== '') {
      setConversation((prev) => [...prev, { text: userQuery, isUser: true }]);
      setQuery('');
      setLoading(true);
      saveMessage('user', userQuery);  // Ensure correct query is saved
      const recentMessages = getRecentMessages();
      console.log("recent 3 conversation : ",recentMessages);
      // Start time measurement
      const startTime = performance.now();
      try { 
        //`https://qet8g8y6ec.execute-api.ap-south-1.amazonaws.com/dev/playlist-videobot/?tag=${tag}&query=${formattedQueryParam}&lang=${lang}`,
        // https://1zyek38fz5.execute-api.ap-south-1.amazonaws.com/dev/playlist-videobot/?tag=${tag}&query=${formattedQueryParam}&lang=${lang}
        const response = await fetch(
          `https://qet8g8y6ec.execute-api.ap-south-1.amazonaws.com/dev/playlist-videobot/?tag=${tag}&query=${formattedQueryParam}&lang=${lang}`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 
              prompt: userQuery, 
              msghistory : recentMessages,
              language: selectedLanguage
            }),
          }
        );
        
        if (response.ok) {
          const data = await response.json();
          const endTime = performance.now();
          const timeTaken = (endTime - startTime)/1000; 
          // console.log(`API call took ${timeTaken.toFixed(2)} seconds`);
          const responseBody = JSON.parse(data.body);
          let responseText = responseBody.response;
          const timestamp = responseBody.Timestamps;
          console.log("Full response text:", responseText); // Debug log
          // Store chat in Firestore
          storeChatMessage(tag, userId, sessionId, chatId, userQuery, responseText, "");
          // Save messages to localStorage
          saveMessage('assistant', responseText);
          // Extract videos

          const videos = responseBody.VideoLinks
            ? responseBody.VideoLinks.map((video) => {
                const url = video.url;
                const gccidMatch = url.match(/gcc-[a-f0-9-]{36}/i);
                const gccid = gccidMatch ? gccidMatch[0] : null;
                return { id: gccid, url, gccid };
              })
            : [];
  
          // Extract documents
          const docs_link = responseBody.DocumentLinks
            ? responseBody.DocumentLinks.map((doc) => ({
                id: doc.id,
                url: doc.url,
              }))
            : [];
          const followUpLine = responseText.split('\n').filter((line) => line.trim() !== '').slice(-1)[0]; // Get the last non-empty line
          // Extract summary information
          const summaryStartIndex = responseText.indexOf("Below are video snippets related to your query:");
          let summaries = [];
          let docs = [];
          if (summaryStartIndex !== -1) {
            const summaryText = responseText.slice(summaryStartIndex);
            // Find the start of the document list (between square brackets [])
            const docMatch = summaryText.match(/(\d+)\s*\(([^)]+)\)\s*-\s*(https?:\/\/[^\s]+)/);
            if (docMatch) {
              try {
                // Extract id and url from regex groups
                docs = [{
                  page_no: docMatch[1].trim(),   
                  id: docMatch[2].trim(),        
                  url: docMatch[3].trim()    
                }];
              } catch (error) {
                console.error("Error parsing document links:", error);
              }
            }
            // Split the summary text into lines and remove empty lines
            const summaryLines = summaryText.split('\n').filter(line => line.trim() !== '');
            for (let i = 1; i < summaryLines.length; i++) {
              const line = summaryLines[i];
              
              const match = line.match(/^(\d{2}:\d{2}:\d{2})\s*\((gcc-[\w-]+)\)\s*-\s*(.+)$/);
              if (match) {
                const summary = {
                  id: match[2], // Use the extracted gcc ID
                  time: match[1],
                  summary: match[3].trim() // Use the third capture group for the summary text
                };
                summaries.push(summary);
              } 
            }
            // Remove the summary part from the responseText
            responseText = responseText.slice(0, summaryStartIndex).trim();
          } else {
            console.log("Summary start phrase not found in the response."); // Debug log
          }
          console.log('Timestamp:', timestamp);
          // console.log('Videos with GCC IDs:', videos);
          console.log("Final Timestamp:", summaries); // Debug log

          console.log('Documents:', docs_link);
          console.log("Final Document:",docs);
          // Fetch video titles
          await fetchVideoTitles(videos);

          setConversation((prev) => [
            ...prev,
            {
              id : chatId,
              text: responseText,
              isUser: false,
              videos,
              docs,
              summaries,
              followUpLine,
              isPlaying: false,
              speechloading: false,
            },
          ]);
        } else {
          setConversation((prev) => [
            ...prev,
            { text: 'An error occurred. Please try again.', isUser: false },
          ]);
        }
      } catch (error) {
        setConversation((prev) => [
          ...prev,
          { text: 'An error occurred. Please try again.', isUser: false },
        ]);
      } finally {
        setLoading(false);
      }
    }
  };  

  const getSpeechResponse = async (text) => {
    const text1 = text.split("Click on a timestamp to jump to that point in the video.")[0];
    // const text2 = text1.trim();
    
    try {
      const response = await fetch('https://7d3m1ntlhf.execute-api.ap-south-1.amazonaws.com/dev/tts-elevenlabs', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ text: text1 }),
      });
  
      if (response.ok) {
        const contentType = response.headers.get('Content-Type');
  
        if (contentType && contentType.includes('application/json')) {
          const data = await response.json();
          let base64Audio = data.body.replace(/\s/g, '');
  
          // Properly pad the base64 string
          while (base64Audio.length % 4 !== 0) {
            base64Audio += '=';
          }
  
          const binaryString = atob(base64Audio);
          const bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }
  
          const blob = new Blob([bytes], { type: 'audio/mpeg' });
          const audioUrl = URL.createObjectURL(blob);
  
          // Set the audio in the ref
          audioRef.current = new Audio(audioUrl);
  
          audioRef.current.oncanplaythrough = () => {
            audioRef.current.play();
            setIsPlaying(true);
          };
  
          audioRef.current.onended = () => {
            setIsPlaying(false);
            URL.revokeObjectURL(audioUrl);
          };
          
          audioRef.current.onerror = (e) => {
            console.error('Audio playback error:', e);
            setIsPlaying(false);
          };
        } else if (contentType.includes('audio')) {
          const blob = await response.blob();
          const audioUrl = URL.createObjectURL(blob);
  
          // Set the audio in the ref
          audioRef.current = new Audio(audioUrl);
  
          audioRef.current.oncanplaythrough = () => {
            audioRef.current.play();
            setIsPlaying(true);
          };
  
          audioRef.current.onended = () => {
            setIsPlaying(false);
            URL.revokeObjectURL(audioUrl);
          };
  
          audioRef.current.onerror = (e) => {
            console.error('Audio playback error:', e);
            setIsPlaying(false);
          };
        }
      }
    } catch (error) {
      console.error('Error fetching or processing speech response:', error);
    } finally {
      setSpeechLoading(false);
    }
  };
  
  const scrollToBottom = () => {
    if (chatbotBodyRef.current) {
      chatbotBodyRef.current.scrollTop = chatbotBodyRef.current.scrollHeight;
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [conversation]);

  const handleInputChange = (event) => {
    setQuery(event.target.value);
    setIsFirstLoad(false);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSend();
    }
  };

  const handleVideoClick = (video, timestamp) => {
    if (video && video.id) {
      seekTo(video.id, timestamp);
    } else {
      console.error("Invalid video or timestamp");
    }
  };
  
  const seekTo = (videoId, startTime) => {
    console.log("inside seekTo function videoID:", videoId, startTime);
  
    if (startTime) {
      const timeParts = startTime.split(':').map(Number);
      if (timeParts.length === 3) {
        const [hours, minutes, seconds] = timeParts;
        const totalSeconds = (hours * 3600) + (minutes * 60) + seconds;
        if (!isNaN(totalSeconds) && isFinite(totalSeconds)) {
          const timeMs = totalSeconds * 1000; // Convert to milliseconds
          return timeMs; // Return the calculated time in milliseconds
        } else {
          console.error("Invalid time format: non-finite value");
          return null; // Return null for invalid values
        }
      } else {
        console.error("Invalid time format: expected HH:MM:SS");
        return null; // Return null for invalid format
      }
    } else {
      console.error("startTime is undefined for video", videoId);
      return null; // Return null for undefined startTime
    }
  };  

  const convertS3ToHttpUrl = (s3Url) => {
    if (!s3Url.startsWith('s3://')) return s3Url;
    const [, bucketAndPath] = s3Url.split('s3://');
    const [bucket, ...pathParts] = bucketAndPath.split('/');
    return `https://${bucket}.s3.amazonaws.com/${pathParts.join('/')}`;
  };

  const handleDownload = (e, url) => {
    e.preventDefault();
    const link = document.createElement('a');
    link.href = url;
    link.download = url.split('/').pop(); // Extracts the file name from the URL
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname});
    console.log("inside use effect of pageview event count")
  }, []);

  const handleFeedback = async (chatId, feedback) => {
    ReactGA.event({
      category: 'Engagement',
      action: 'Feedback',
      label: feedback
    });
  
    try {
       // Call updateChatFeedback function
      await updateChatFeedback(tag, userId, sessionId, chatId, feedback);
    } catch (error) {
      console.error("Error updating feedback: ", error);
    }
  };

  const renderVideos = (summaries) => {
    if(!summaries || summaries.length === 0) return null;
    return (
      <div className="video-section">
        {/* <div className="instruction">Watch here:</div>
         */}
        {/* <div className='sub-instruction'>The following documents provide additional information</div> */}
                {summaries.map((video, vidIndex) => {
                  return (
                    <div key={vidIndex} className="video-thumbnail">
                      <KpointPlayer
                        key={video.id}  // Add a key prop with unique video ID
                        onVideoLoad={(el) => {
                          if (el) {
                            playerRefs.current[video.id] = el;  // Store reference of the player
                          }
                        }}
                        hostUrl="https://assets.kpoint.com/orca/media/embed/videofront-vega.js"
                        videoHost="ktpl.kpoint.com"
                        videoId={video.id}  // Ensure this is the correct video ID
                        playerId={`player-${video.id}`}  // Assign a unique player ID
                        // responseId={msg.responseId}
                        width="100%"
                        height="auto"
                        offset={(function () {
                          if (video.time) {
                            const timeParts = video.time.split(':').map(Number);
                            if (timeParts.length === 3) {
                              const [hours, minutes, seconds] = timeParts;
                              const totalSeconds = hours * 3600 + minutes * 60 + seconds;
                              return totalSeconds * 1000;  // Convert to milliseconds
                            }
                          }
                          return 0; // Default offset if no timestamp is available
                        })()}
                        onPlayerReady={(playerRef) => {
                          handlePlayerReady(playerRef, video.id);
                        }}
                        onStateChange={(state) => {
                          onStateChange(state, video.id);
                        }}
                      />
                      <div className="thumbnail-title">
                        {video ? (
                          <span className="timestamp">{(video.summary)}</span>
                        ) : (
                          'No summary available'
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
    );
  };
  
  const renderDocuments = (docs) => {
    if (!docs || docs.length === 0) return null;
    return (
      <div className="document-section">
        <div className="instruction">Read more:</div>
        <div className='sub-instruction'>The following documents provide additional information</div>
        {docs.map((doc, i) => {
          const httpUrl = convertS3ToHttpUrl(doc.url);
          const pdfUrlWithPage = `${httpUrl}#page=${doc.page_no}`; // Append page number to URL
          return (
            
            <div key={i} className="document-item"href={pdfUrlWithPage} target="_blank" >
              <FontAwesomeIcon icon={faFilePdf} className="document-icon" />
                <span className="document-name">{doc.id}</span>
                <a href={pdfUrlWithPage} target="_blank" rel="noopener noreferrer" className="preview-icon">
                  <FontAwesomeIcon icon={faEye} />
                </a>
                {/* <a href={pdfUrlWithPage} target="_blank" rel="noopener noreferrer" className='page-info'>
                  Page {doc.page_no} 
                </a> */}
              </div>
          );
        })}
      </div>
    );
  };

  const renderMessage = (msg, index) => {
    // if (!msg || !msg.text) return null;

    // const parts = msg.text.split('\n');
    // const renderedParts = [];
    // let videoSummaryPart = null;

    // parts.forEach((line, i) => {
    //   if (line.startsWith(msg.followUpLine)) {
    //     videoSummaryPart = line;
    //   } else if (!line.match(/^\d{2}:\d{2}:\d{2}/)) { // If not a timestamp line
    //     renderedParts.push(<div className='message-space' key={i}>{line}</div>);
    //   }
    // });

    if (!msg || !msg.text) return null;

    const formatLine = (line) => {
      // Handle main bullet points (starting with •)
      if (line.startsWith('•')) {
        return <div className="main-bullet">{line}</div>;
      }
      // Handle nested bullet points (starting with -)
      else if (line.startsWith('-')) {
        return <div className="nested-bullet">{line}</div>;
      }
      // Regular text
      return <div className="message-space">{line}</div>;
    };

    const parts = msg.text.split('\n');
    const renderedParts = parts.map((line, i) => {
      if (line.startsWith(msg.followUpLine)) {
        return null;
      } else if (!line.match(/^\d{2}:\d{2}:\d{2}/)) {
        return <div key={i}>{formatLine(line)}</div>;
      }
      return null;
    }).filter(Boolean);
  
    // Audio play/stop buttons
    const handleAudioPlay = async () => {
      const updatedConversation = [...conversation];
      updatedConversation[index].speechloading = true;
      setConversation(updatedConversation);
      await getSpeechResponse(msg.text);
      updatedConversation[index].isPlaying = true;
      updatedConversation[index].speechloading = false;
      setConversation(updatedConversation);
    };
  
    const handleStopAudio = () => {
      if (audioRef.current) {
        audioRef.current.pause();
        const updatedConversation = [...conversation];
        updatedConversation[index].isPlaying = false;
        setConversation(updatedConversation);
      }
    };
  
    return (
      <div>
        {renderedParts}
        {msg.docs && renderDocuments(msg.docs)}
        {msg.summaries && renderVideos(msg.summaries)}
        {/* <div>
          {msg.speechloading ? (
            <ClipLoader className='speech-ClipLoader-small' size={10} color="#30c484" />
          ) : msg.isPlaying ? (
            <button className="speech-stop-button" onClick={handleStopAudio}>
              <FaStop />
            </button>
          ) : (
            <button className="speech-button" onClick={handleAudioPlay}>
              <FaVolumeUp />
            </button>
          )}
        </div> */}
      </div>
    );
  };

  return (
    <div className='main-container'>
    <div className="chatbot-container">
      <div className="chatbot-header">
        <img className="icon" alt="icon" src={Icon} />
        <span>KPOINT Prism</span>
      </div>
      
      <div className="chatbot-body" ref={chatbotBodyRef}>
        {conversation.map((msg, index) => (
          <div className={`message ${msg.isUser ? 'user-message' : 'bot-message'}`}>
            {renderMessage(msg, index)}
            {/* {msg.summaries && (
              <div className="video-section">
                {msg.summaries.map((video, vidIndex) => {
                  return (
                    <div key={vidIndex} className="video-thumbnail">
                      <KpointPlayer
                        key={video.id}  // Add a key prop with unique video ID
                        onVideoLoad={(el) => {
                          if (el) {
                            playerRefs.current[video.id] = el;  // Store reference of the player
                          }
                        }}
                        hostUrl="https://assets.kpoint.com/orca/media/embed/videofront-vega.js"
                        videoHost="ktpl.kpoint.com"
                        videoId={video.id}  // Ensure this is the correct video ID
                        playerId={`player-${video.id}`}  // Assign a unique player ID
                        responseId={msg.responseId}
                        width="100%"
                        height="auto"
                        offset={(function () {
                          if (video.time) {
                            const timeParts = video.time.split(':').map(Number);
                            if (timeParts.length === 3) {
                              const [hours, minutes, seconds] = timeParts;
                              const totalSeconds = hours * 3600 + minutes * 60 + seconds;
                              return totalSeconds * 1000;  // Convert to milliseconds
                            }
                          }
                          return 0; // Default offset if no timestamp is available
                        })()}
                        onPlayerReady={(playerRef) => {
                          handlePlayerReady(playerRef, video.id);
                        }}
                        onStateChange={(state) => {
                          onStateChange(state, video.id);
                        }}
                      />
                      <div className="thumbnail-title">
                        {video ? (
                          <span className="timestamp">{(video.summary)}</span>
                        ) : (
                          'No summary available'
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
              )} */}
              <div>
              {msg.followUpLine && (
                <div className='followup'>{msg.followUpLine}</div>
              )}
              </div>
              {!msg.isUser && (
              <div>
                  <button className="feedback-button" onClick={() => handleFeedback(msg.id, 'Like')} >
                    <FontAwesomeIcon icon={faThumbsUp}/>
                  </button>
                  <button className="feedback-button" onClick={() => handleFeedback(msg.id, 'Dislike')}>
                    <FontAwesomeIcon icon={faThumbsDown}/>
                  </button>
              </div>
              )}
          </div>
        ))}
        {loading && (
          <div className="loader-container">
            <PulseLoader size={8} color="#30c484" />
          </div>
        )}
      </div>

      <div className="chatbot-footer">
      
        <input
          className="chat-input"
          type="text"
          value={query}
          placeholder={placeholder}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
        />
        <button onClick={handleSend}>
          <FaPaperPlane />
        </button>
        {/* <button id='startrecording' onClick={handleRecording}>
          <FaMicrophone/>
        </button> */}
        <select
          className="language-select"
          id="languageSelect"
          value={selectedLanguage}
          onChange={handleLanguageChange}   
        > 
          <option value="English">English</option>
          <option value="Bengali">Bengali</option>
          <option value="Gujarati">Gujarati</option>
          <option value="Hindi">Hindi</option>
          <option value="Kannada">Kannada</option>
          <option value="Malayalam">Malayalam</option>
          <option value="Marathi">Marathi</option>
          <option value="Punjabi">Punjabi</option>
          <option value="Tamil">Tamil</option>
          <option value="Telugu">Telugu</option>
        </select>
      </div>
    </div>
    </div>
  );
};

export default Chatbot;
